export default __webpack_public_path__ + "static/media/home.6660b146.svg";